import _reduced from "ramda/src/reduced";
import _isNil from "ramda/src/isNil";
import _applyTo from "ramda/src/applyTo";
import _reduce from "ramda/src/reduce";
import _toLower from "ramda/src/toLower";
import _prop from "ramda/src/prop";
import _clone from "ramda/src/clone";
import _when from "ramda/src/when";
import _adjust from "ramda/src/adjust";
import _pipe from "ramda/src/pipe";
import _uncurryN from "ramda/src/uncurryN";
import _identity from "ramda/src/identity";
import _ifElse from "ramda/src/ifElse";
import _map from "ramda/src/map";
import _useWith from "ramda/src/useWith";
import _flip from "ramda/src/flip";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _fromPairs from "ramda/src/fromPairs";
import _toPairs from "ramda/src/toPairs";
import _forEach from "ramda/src/forEach";
import _curry from "ramda/src/curry";
var jsonpatch = require('fast-json-patch');
import { isTypeOf, isObject } from "../../browser/is";
var isObjectType = isTypeOf('object');
export var forEachPairs = _curry(function (pred, obj) {
  _forEach(pred, _toPairs(obj));
  return obj;
});
export var mapPairs = _curry(function (pred, obj) {
  var pairs = _toPairs(obj).map(pred);
  return _fromPairs(pairs);
});
export var mapKeys = _curry(function (pred, obj) {
  return mapPairs(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return [pred(key), value];
  }, obj);
});
export var mapValues = _curry(function (pred, obj) {
  return mapPairs(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      value = _ref4[1];
    return [key, pred(value)];
  }, obj);
});
export var deepFreeze = function deepFreeze(obj) {
  if (!obj) return obj;
  Object.freeze(obj);
  for (var _i = 0, _Object$values = Object.values(obj); _i < _Object$values.length; _i++) {
    var value = _Object$values[_i];
    if (isObjectType(value)) deepFreeze(value);
  }
  return obj;
};
export var isEmpty = function isEmpty(obj) {
  return !Object.keys(obj).length;
};
export var toHumanJSON = function toHumanJSON(json) {
  return JSON.stringify(json, null, 2);
};
export var del = _curry(function (prop, obj) {
  return delete obj[prop], obj;
});
export var clear = function clear(obj) {
  return Object.keys(obj).reduce(_flip(del), obj);
};
export var mapDeep = _useWith(_map, [function (pred) {
  return _ifElse(isObject, mapDeep(pred), pred);
}, _identity]);
export var mapKeysDeep = _uncurryN(2, function (pred) {
  return mapPairs(_pipe(_adjust(0, pred), _adjust(1, _when(isObject, mapKeysDeep(pred)))));
});
export var diff = _curry(function (obj1, obj2) {
  return jsonpatch.compare(obj1, obj2);
});
export var patch = _curry(function (patch, data) {
  return jsonpatch.applyPatch(_clone(data), patch).newDocument;
});
export var caselessProp = _useWith(_prop, [function (key) {
  return _toLower("".concat(key));
}, mapKeys(_toLower)]);
export var caselessPath = _curry(function (path, obj) {
  return _reduce(function (result, key) {
    return _applyTo(result, _pipe(caselessProp(key), _when(_isNil, _reduced)));
  }, obj, path);
});
export var caselessPathOr = _curry(function (fallback, key, obj) {
  return _applyTo(obj, _pipe(caselessPath(key), _when(_isNil, function (_) {
    return fallback;
  })));
});